import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-new-button',
  templateUrl: './add-new-button.component.html',
  styleUrls: ['./add-new-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNewButtonComponent {
  @Input() label = '';
  @Input() disabled = false;
  @Output() buttonClicked = new EventEmitter();

  constructor() { }

  onAddNewButtonClicked(): void {
    this.buttonClicked.emit();
  }
}
